import React, { useState } from "react";
import Layout from "../layout/Layout";
import styles from "./NavigationMenu.module.css";
import { User } from "../../gql/types";
import ProfileMenuRow from "../profile/ProfileMenuRow";
import ProfileView from "../profile/ProfileView";

interface NavigationMenuProps {
    onCloseMenu: () => void;
    user?: User;
    isHidden?: boolean;
}

const NavigationMenu: React.FC<NavigationMenuProps> = ({ onCloseMenu, user, isHidden }) => {
    const [profileViewVisible, setProfileViewVisible] = useState<boolean>(false);

    return (
        <>
            <Layout
                navbarConfig={{ title: "This is Menu", showLogo: true, hamburgerMenu: false, onBack: onCloseMenu, useCloseButton: true }}
                footer={(
                    <>
                        {user && <ProfileMenuRow
                            name={user.firstName + " " + user.lastName}
                            profilePictureUrl={user.profilePictureUrl ?? undefined}
                            onClick={() => setProfileViewVisible(true)}
                        />}
                    </>
                )
                }
                noFooterPadding={true}
                footerClassName={styles.fillPaddingProfileRow}
                isHidden={profileViewVisible || isHidden}
            >
                <div className={styles.navigationMenu}>
                    <div className={styles.menuSection}>
                        <div className={styles.menuCategory}>Planning</div>
                        <div className={styles.menuItem} onClick={(e) => {
                            // your onClick logic here
                        }}>
                            Childcare Request
                        </div>
                        <div className={styles.menuItem} onClick={(e) => {
                            // your onClick logic here
                        }}>
                            Coordinate Event
                        </div>
                    </div>
                </div>
            </Layout >
            {user && <ProfileView user={user} onBack={() => setProfileViewVisible(false)} isHidden={!profileViewVisible} />}
        </>
    );
};

export default NavigationMenu;
